import Icon from "../Icon";

const coin = `<ellipse rx="8.5" ry="9" transform="matrix(-1 0 0 1 10.5 12)"/><path d="M13 8.8a3.583 3.583 0 0 0-2.25-.8C8.679 8 7 9.79 7 12s1.679 4 3.75 4c.844 0 1.623-.298 2.25-.8"/><path d="M11 3c3.667 0 11 .9 11 9s-7.333 9-11 9"/>`;

export default Icon(coin);
